import { Injectable } from '@angular/core';
import { base_config } from '../config/global';
import { proyecto_config } from '@app/proyecto/config/global';

@Injectable({ providedIn: 'root' })
export class ConfigService {
    private _config: Object = {};

    constructor() {}

    load() {
        this._config = this.mergeDeep(base_config, proyecto_config);
    }

    get config() {
        return this.mergeDeep({}, this._config);
    }

    mergeDeep(target: any, ...sources: any): any {
        if (!sources.length) return target;
        const source = sources.shift();

        if (this.isObject(target) && this.isObject(source)) {
            for (const key in source) {
                if (this.isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    this.mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
        return this.mergeDeep(target, ...sources);
    }

    isObject(item: any) {
        return item && typeof item === 'object' && !Array.isArray(item);
    }
}
